import { Spacing } from "components/designV2/constants";
import styled from "styled-components";

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;
  margin-bottom: ${Spacing.md}px;
`;

export const ButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;
`;

export const PdfFrame = styled.iframe`
  flex: 1;
  width: 100%;
  min-height: 60vh;
  border: 1px solid #ccc;
`;
